import { useNavigate, useRouteError } from "react-router-dom";
import styles from "./errorPage.module.scss";

export const ErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const error: any = useRouteError();

  return (
    <div className="grid h-full w-full place-items-center">
      <div className="space-y-4 text-center">
        <h1>Oops!</h1>
        <p>Si e' verificato un problema. Riprova piu' tardi.</p>
        <div
          className={styles.buttonHome}
          onClick={() => navigate(`/assistant/`)}
        >
          Vai alla homepage
        </div>
        <p className="text-gray-500">
          <i>{error.statusText || error.message}</i>
        </p>
      </div>
    </div>
  );
};
